<template>
  <div>
    <NewGenericBTable
      :key="generic_table_key"
      :search_filter="false"
      :fields="fields"
      :pre_filter="tablePreFilter"
      :url="'/evaluations2/evaluation/'"
      :draggable_rows="reorderable && allows_crud"
      :pagination="reorderable ? 100 : undefined"
      :show_pagination="!reorderable"
      @actual_items="FetchInstrument"
      @row-reorder="handleRowReorder"
    >
      <template #cell(title)="row">
        <div
          v-if="!redirect_to_evaluatee_view"
          class="div-href"
          @click="redirectToEvaluation(row.item.id)"
        >
          {{ row.item.title }}
        </div>
        <div
          v-else-if="
            new_tests.some(
              (x) =>
                x.evaluation == row.item.id && x.visible_by_evaluatees === true
            )
          "
          class="div-href"
          @click="redirectToEvaluateeEvaluation(row.item.id)"
        >
          {{ row.item.title }}
        </div>
        <div v-else-if="redirect_to_evaluatee_view">
          <span
            v-b-tooltip.v-secondary.left.noninteractive="
              `${$getVisibleNames(
                'evaluations2.evaluation',
                false,
                'Instrumento'
              )} ${$t('evaluations.newEvaluations.notAvailable')}`
            "
          >
            {{ row.item.title }}
          </span>
        </div>
      </template>
      <template #cell(description)="row">
        <RenderVHtml :content="row.item.description"></RenderVHtml>
      </template>
      <template #cell(scope)="row">
        {{ findScopedId(row.item.scope_id) }}
      </template>
      <template #head(instrument)="head">
        <div class="d-none">{{ head.label }}</div>
      </template>
      <template #cell(instrument)="row">
        <div>
          <b-table-simple bordered small responsive hover>
            <b-thead>
              <b-tr>
                <b-th class="th-class">{{
                  $getVisibleNames("evaluations2.test", false, "Instrumento")
                }}</b-th>
                <b-th class="th-class">{{
                  $t("evaluations.newEvaluations.score")
                }}</b-th>
                <b-th class="th-class">{{
                  $t("evaluations.newEvaluations.weighting")
                }}</b-th>
                <b-th class="th-class">{{
                  $getVisibleNames(
                    "manual.test.agente_evaluativo",
                    false,
                    "Tipo"
                  )
                }}</b-th>
                <b-th class="th-class" v-if="evaluation_scoped == 1">{{
                  $t("reusable.common.startDate")
                }}</b-th>
                <b-th class="th-class">
                  <template>
                    <button-add
                      v-if="allows_crud && !row.item.test_creation_is_locked"
                      :title="
                        $t('reusable.common.createTooltip', {
                          entity: $getVisibleNames(
                            'evaluations2.test',
                            false,
                            'Instrumento'
                          ),
                        })
                      "
                      v-b-tooltip.v-secondary.left.noninteractive="
                        $t('reusable.common.createTooltip', {
                          entity: $getVisibleNames(
                            'evaluations2.test',
                            false,
                            'Instrumento'
                          ),
                        })
                      "
                      @click="
                        $bvModal.show(`modal-created-instrument-${row.item.id}`)
                      "
                      size="sm"
                    >
                    </button-add>
                    <ButtonSmall
                      v-if="
                        allows_crud &&
                        user &&
                        ['PROFESORES'].some((group) =>
                          user.group_names.includes(group)
                        ) &&
                        section(row.item.scope_id) &&
                        available_sections_to_replicate_section_evaluation_all.filter(
                          (x) => x.compare_evaluation == row.item.id
                        ).length > 0 &&
                        !row.item.test_creation_is_locked &&
                        row.item.scope == 1
                      "
                      :tooltip_text="
                        $t('evaluations.newEvaluations.replicateEvaluationTo', {
                          entity: $getVisibleNames(
                            'evaluations2.evaluation',
                            false,
                            'Evaluación'
                          ),
                          sections: $getVisibleNames(
                            'teaching.section',
                            true,
                            'Secciones'
                          ),
                        })
                      "
                      :text_button="``"
                      :click_button="
                        () =>
                          openReplicateEvaluationInSectionEvaluation(row.item)
                      "
                      :icon="'files'"
                      :variant="'none'"
                      :custom_class="`ml-1`"
                    >
                    </ButtonSmall>
                    <b-modal
                      :id="`modal-created-instrument-${row.item.id}`"
                      :title="
                        $t('reusable.common.createModalTitle', {
                          entity: $getVisibleNames(
                            'evaluations2.test',
                            false,
                            'Instrumento'
                          ),
                        })
                      "
                      size="xl"
                      @hide="confirmClose"
                      hide-footer
                    >
                      <NewInstrumentForm
                        :evaluation_id="row.item.id"
                        :show_step="
                          row.item.matter_evaluation != null ||
                          row.item.egress_profile_matter_evaluation != null
                        "
                        @change_evaluation_form="
                          () => (change_evaluation_form = true)
                        "
                        @closeModal="
                          $bvModal.hide(
                            `modal-created-instrument-${row.item.id}`
                          )
                        "
                      ></NewInstrumentForm>
                    </b-modal>
                    <b-modal
                      :id="`modal-copy-evaluation-in-section-evaluation-${row.item.id}`"
                      @hide="
                        () => {
                          selected_section_evaluation_ids = [];
                        }
                      "
                      hide-footer
                      size="lg"
                    >
                      <template #modal-title>
                        <div class="d-flex">
                          {{
                            $t(
                              "evaluations.newEvaluations.replicateEvaluationInOtherSections",
                              {
                                entity: $getVisibleNames(
                                  "evaluations2.evaluation",
                                  false,
                                  "Evaluación"
                                ),
                                sections: $getVisibleNames(
                                  "teaching.section",
                                  true,
                                  "Secciones"
                                ),
                                subject: $getVisibleNames(
                                  "mesh.egressprofilematter",
                                  false,
                                  "Asignatura"
                                ),
                              }
                            )
                          }}
                        </div>
                      </template>
                      <b-form-group
                        :label="
                          $t(
                            'evaluations.newEvaluations.selectSectionsToReplicate',
                            {
                              entity: $getVisibleNames(
                                'teaching.section',
                                true,
                                'Secciones'
                              ).toLowerCase(),
                            }
                          )
                        "
                        label-for="selected_section_evaluation_ids"
                        label-cols="0"
                        label-cols-sm="auto"
                        label-cols-md="auto"
                        class="m-0 p-0 mb-2"
                      >
                        <v-select
                          class="mt-1"
                          id="selected_section_evaluation_ids"
                          :placeholder="
                            $t(
                              'evaluations.newEvaluations.selectOneOrMoreToFilter'
                            )
                          "
                          track-by="id"
                          label="name"
                          size="sm"
                          v-model="selected_section_evaluation_ids"
                          :options="
                            available_sections_to_replicate_section_evaluation
                          "
                          :reduce="(s) => s.id"
                          :disabled="!allows_crud"
                          :dropdown-should-open="dropdownShouldOpen3"
                          multiple
                          :selectable="
                            (option) =>
                              !selected_section_evaluation_ids.includes(
                                option.id
                              )
                          "
                        >
                          <template v-slot:no-options="{ search, searching }">
                            <template v-if="searching">
                              {{
                                $t(
                                  "evaluations.newEvaluations.noResultsFoundFor"
                                )
                              }}
                              <em>{{ search }}</em
                              >.
                            </template>
                          </template>

                          <!-- Opciones en el dropdown -->
                          <template v-slot:option="item">
                            <div v-if="item.id == 'all'">
                              <span>{{ item.name }}</span>
                            </div>
                            <div
                              v-else-if="
                                !selected_section_evaluation_ids.includes(
                                  item.id
                                )
                              "
                              v-b-tooltip.v-secondary.noninteractive.hover.right="{
                                title:
                                  $t(
                                    'evaluations.newEvaluations.additionalInformationOf',
                                    { entity: item.name }
                                  ) +
                                  `: - ${item.shift__name} - ${item.period__name} - ${item.campus__name}`,
                                boundary: 'viewport',
                              }"
                            >
                              <b-badge>
                                {{ item.name }} - {{ item.period__name }}
                              </b-badge>
                            </div>
                            <div v-else>
                              <b-badge>
                                {{ item.name }} - {{ item.period__name }}
                              </b-badge>
                            </div>
                          </template>

                          <!-- Tags seleccionados con tooltip y color -->
                          <template v-slot:selected-option="item">
                            <b-badge
                              v-b-tooltip.v-secondary.noninteractive.hover="{
                                title:
                                  $t(
                                    'evaluations.newEvaluations.additionalInformationOf',
                                    { entity: item.name }
                                  ) +
                                  `: - ${item.shift__name} - ${item.period__name} - ${item.campus__name}`,
                                boundary: 'viewport',
                              }"
                            >
                              {{ item.name }}
                            </b-badge>
                          </template>
                        </v-select>
                      </b-form-group>
                      <div class="d-flex">
                        <b-button
                          class="ml-auto mr-0"
                          size="sm"
                          @click="
                            replicateEvaluationInSectionEvaluation(row.item)
                          "
                          :disabled="
                            selected_section_evaluation_ids.length == 0 ||
                            disable_replicate_buttons
                          "
                        >
                          {{ $t("reusable.common.apply") }}
                        </b-button>
                      </div>
                    </b-modal>

                    <b-modal
                      :id="`modal-redirect-to-evaluation-${row.item.id}`"
                      :title="
                        $t('evaluations.newEvaluations.replicatedEvaluations', {
                          entity: $getVisibleNames(
                            'evaluations2.evaluation',
                            true,
                            'Evaluaciones'
                          ),
                        })
                      "
                      @hide="
                        () => {
                          selected_sections_details = [];
                        }
                      "
                      hide-footer
                      size="lg"
                    >
                      <b-form-group
                        :label="
                          $t(
                            'evaluations.newEvaluations.evaluationsReplicatedInSections',
                            {
                              entity: $getVisibleNames(
                                'evaluations2.evaluation',
                                true,
                                'Evaluaciones'
                              ),
                            }
                          )
                        "
                        label-for="selected_section_evaluation_ids"
                        label-cols="0"
                        label-cols-sm="auto"
                        label-cols-md="auto"
                        class="m-0 p-0 mb-2 d-flex align-items-center"
                      >
                      </b-form-group>
                      <template
                        v-for="section_selected in selected_sections_details.replicated_sections"
                      >
                        <div :key="section_selected.id">
                          <span
                            v-b-tooltip.v-secondary.noninteractive.hover.right="{
                              title:
                                $t(
                                  'evaluations.newEvaluations.additionalInformationOf',
                                  { entity: section_selected.section_name }
                                ) +
                                `: - ${section_selected.shift__name} - ${section_selected.period__name} - ${section_selected.campus__name}`,
                              boundary: 'viewport',
                            }"
                            class="div-href"
                            @click="
                              redirectToEvaluationReplicated(
                                section_selected.evaluation_id
                              )
                            "
                          >
                            -{{ section_selected.section_name }} -
                            {{ section_selected.period__name }}
                          </span>
                        </div>
                      </template>
                      <div class="d-flex">
                        <b-button
                          class="ml-auto mr-0"
                          size="sm"
                          @click="
                            $bvModal.hide(
                              `modal-redirect-to-evaluation-${row.item.id}`
                            )
                          "
                        >
                          {{ $t("reusable.common.close") }}
                        </b-button>
                      </div>
                    </b-modal>
                  </template>
                </b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <template v-if="filterTest(row.item.id).length > 0">
                <b-tr
                  v-for="item in filterTest(row.item.id)"
                  :key="'instrument:' + item.id"
                >
                  <b-td class="td-class">
                    <div
                      v-if="!redirect_to_evaluatee_view"
                      class="div-href"
                      @click="redirectToEvaluation(row.item.id, item.id)"
                    >
                      {{ item.title }}
                    </div>
                    <div
                      v-else-if="item.visible_by_evaluatees"
                      class="div-href"
                      @click="
                        redirectToEvaluateeEvaluation(row.item.id, item.id)
                      "
                    >
                      {{ item.title }}
                    </div>
                    <div v-else-if="redirect_to_evaluatee_view">
                      <span
                        v-b-tooltip.v-secondary.left.noninteractive="
                          `${$getVisibleNames(
                            'evaluations2.test',
                            false,
                            'Instrumento'
                          )} ${$t('evaluations.newEvaluations.notAvailable')}`
                        "
                      >
                        {{ item.title }}
                      </span>
                    </div>
                  </b-td>
                  <b-td class="td-class">
                    {{ item.max_score }}
                  </b-td>
                  <b-td
                    class="td-class"
                    :class="{
                      'weighing-error': !isWeighingSumValid(row.item.id),
                    }"
                  >
                    <span
                      v-if="!isWeighingSumValid(row.item.id)"
                      v-b-tooltip.v-secondary.left.noninteractive="
                        filterTest(row.item.id).length > 1
                          ? $t(
                              'evaluations.newEvaluations.sumWeightingsMustBe100'
                            )
                          : $t('evaluations.newEvaluations.weightingMustBe100')
                      "
                    >
                      {{ item.weighing }}%
                    </span>
                    <span v-else> {{ item.weighing }}% </span>
                  </b-td>
                  <b-td class="td-class">
                    <span
                      v-b-tooltip.v-secondary.left.noninteractive="
                        $t('evaluations.newEvaluations.type')
                      "
                    >
                      <span v-if="item.evaluative_agent">
                        {{
                          (
                            typesDefault.find(
                              (x) => x.id == item.evaluative_agent
                            ) || {}
                          ).name || $t("reusable.common.notApplicable")
                        }}
                      </span>
                      <span v-else>
                        {{ $t("reusable.common.notApplicable") }}</span
                      >
                    </span>
                  </b-td>
                  <b-td class="td-class" v-if="evaluation_scoped == 1">
                    <span v-if="item.start_time">
                      {{ item.start_time | FormatToDateTime }} </span
                    ><span v-else>{{
                      $t("evaluations.newEvaluations.noStartDate")
                    }}</span>
                  </b-td>
                  <b-td class="td-class">
                    <ButtonSmall
                      v-if="
                        (row.item &&
                          allows_crud &&
                          user &&
                          !user.group_names.includes('PROFESORES')) ||
                        (row.item &&
                          item.manual_is_valid &&
                          user &&
                          !user.group_names.includes('PROFESORES'))
                      "
                      :tooltip_text="
                        item.is_locked
                          ? $t('evaluations.newEvaluations.isClosedEntity', {
                              entity: $getVisibleNames(
                                'evaluations2.test',
                                false,
                                'Instrumento',
                                true
                              ),
                            })
                          : $t('evaluations.newEvaluations.unlockEntity', {
                              entity: $getVisibleNames(
                                'evaluations2.test',
                                false,
                                'Instrumento',
                                true
                              ),
                            })
                      "
                      :text_button="``"
                      :click_button="() => changeStateTest(item)"
                      :icon="item.is_locked ? 'lock' : 'unlock'"
                      :custom_class="`mr-2`"
                      :disabled_button="item.manual_is_valid"
                    >
                    </ButtonSmall>
                    <button-edit
                      size="sm"
                      v-if="
                        (allows_crud && row.item && !item.is_locked) ||
                        (allows_crud &&
                          row.item &&
                          item.is_locked &&
                          user &&
                          user.group_names.includes('PROFESORES'))
                          ? allows_crud
                          : false
                      "
                      v-b-tooltip.v-secondary.topright.noninteractive="
                        $t('reusable.common.editTooltip', {
                          entity: $getVisibleNames(
                            'evaluations2.test',
                            false,
                            'Instrumento'
                          ),
                        })
                      "
                      @click="$bvModal.show(`modal-edit-instrument-${item.id}`)"
                    ></button-edit>
                    <div
                      v-if="
                        allows_crud &&
                        !existEvaluateeTest(item.id) &&
                        !item.is_locked
                      "
                      style="display: inline-block"
                    >
                      <button-delete
                        size="sm"
                        v-b-tooltip.v-secondary.topright.noninteractive="
                          $t('reusable.common.deleteTooltip', {
                            entity: $getVisibleNames(
                              'evaluations2.test',
                              false,
                              'Instrumento'
                            ),
                          })
                        "
                        @click="askForDeleteInstrument(item.id)"
                      ></button-delete>
                    </div>
                    <button-delete
                      v-else-if="
                        allows_crud &&
                        user &&
                        user.is_superuser &&
                        !item.is_locked
                      "
                      size="sm"
                      v-b-tooltip.v-secondary.topright.noninteractive="
                        $t('reusable.common.deleteTooltip', {
                          entity: $getVisibleNames(
                            'evaluations2.test',
                            false,
                            'Instrumento'
                          ),
                        })
                      "
                      @click="askForDeleteInstrument(item.id)"
                    ></button-delete>
                    <div
                      v-else-if="
                        allows_crud &&
                        existEvaluateeTest(item.id) &&
                        !item.is_locked
                      "
                      v-b-tooltip.v-secondary.topright.noninteractive="
                        $t(
                          'evaluations.newEvaluations.cannotDeleteStudentEntered'
                        )
                      "
                      style="display: inline-block"
                    >
                      <button-delete size="sm" disabled></button-delete>
                    </div>
                    <!-- Replicar Instrumento -->
                    <ButtonSmall
                      v-if="
                        allows_crud &&
                        !row.item.test_creation_is_locked &&
                        ((sectionsProfessor.length > 0 &&
                          row.item.scope == 1) ||
                          [2, 3].includes(row.item.scope))
                      "
                      :tooltip_text="
                        $t('reusable.common.replicateTooltip', {
                          entity: $getVisibleNames(
                            'evaluations2.test',
                            false,
                            'Instrumento'
                          ),
                        }) +
                        ([2, 3].includes(row.item.scope)
                          ? ' ' +
                            $t('evaluations.newEvaluations.toOtherEvaluations')
                          : '')
                      "
                      :text_button="``"
                      :click_button="() => openReplicateTest(row.item, item)"
                      :icon="'files'"
                      :variant="'none'"
                      :custom_class="``"
                    >
                    </ButtonSmall>
                    <b-modal
                      :id="`modal-copy-instrument-${row.item.id}-${item.id}`"
                      :title="
                        $t(
                          'evaluations.newEvaluations.replicateInstrumentInOtherEvaluations',
                          {
                            entity: $getVisibleNames(
                              'evaluations2.test',
                              false,
                              'Instrumento'
                            ),
                          }
                        )
                      "
                      @hide="
                        () => {
                          selected_evaluations_ids = [];
                          current_test_id = null;
                          current_evaluation_id = null;
                          generic_table_key++;
                        }
                      "
                      hide-footer
                      size="lg"
                    >
                      <b-form-group
                        :label="
                          $t(
                            'evaluations.newEvaluations.selectEvaluationsToReplicate'
                          )
                        "
                        label-for="selected_evaluations_ids"
                        label-cols="0"
                        label-cols-sm="auto"
                        label-cols-md="auto"
                        class="m-0 p-0 mb-2"
                      >
                        <v-select
                          class="mt-1"
                          id="selected_evaluations_ids"
                          :placeholder="
                            $t(
                              'evaluations.newEvaluations.selectOneOrMoreToFilter'
                            )
                          "
                          track-by="id"
                          label="full_name"
                          size="sm"
                          v-model="selected_evaluations_ids"
                          :options="replicateEvaluationsList"
                          :reduce="
                            (replicateEvaluationsList) =>
                              replicateEvaluationsList.id
                          "
                          :disabled="!allows_crud"
                          :dropdown-should-open="dropdownShouldOpen"
                          multiple
                          :selectable="
                            (option) =>
                              !selected_evaluations_ids.includes(option.id) &&
                              option.is_active !== false
                          "
                        >
                          <template
                            v-slot:selected-option-container="{
                              option,
                              deselect,
                              disabled,
                            }"
                          >
                            <span class="vs__selected">
                              <span
                                :class="{
                                  'text-muted': option.is_active === false,
                                }"
                              >
                                {{ option.full_name }}
                                <small
                                  v-if="option.is_active === false"
                                  class="text-danger"
                                >
                                  {{
                                    $t(
                                      "evaluations.newEvaluations.closedParentheses"
                                    )
                                  }}
                                </small>
                              </span>
                              <button
                                v-if="!disabled && !option.disabled"
                                :disabled="disabled"
                                type="button"
                                class="vs__deselect"
                                :title="
                                  $t('evaluations.newEvaluations.removeOption')
                                "
                                @mousedown.prevent.stop="deselect(option)"
                              >
                                <b-icon-x variant="danger"></b-icon-x>
                              </button>
                            </span>
                          </template>
                          <template v-slot:no-options="{ search, searching }">
                            <template v-if="searching">
                              {{
                                $t(
                                  "evaluations.newEvaluations.noResultsFoundFor"
                                )
                              }}
                              <em>{{ search }}</em
                              >.
                            </template>
                          </template>
                          <template v-slot:option="option">
                            {{ option.full_name }}
                            <small
                              v-if="option.is_active === false"
                              class="text-danger"
                            >
                              {{
                                $t(
                                  "evaluations.newEvaluations.closedParentheses"
                                )
                              }}
                            </small>
                          </template>
                        </v-select>
                      </b-form-group>
                      <div class="d-flex">
                        <b-button
                          class="ml-auto mr-0"
                          size="sm"
                          @click="replicateTests()"
                          :disabled="
                            selected_evaluations_ids.length == 0 ||
                            disable_replicate_buttons
                          "
                        >
                          {{ $t("reusable.common.apply") }}
                        </b-button>
                      </div>
                    </b-modal>
                    <b-modal
                      :id="`modal-redirect-to-evaluation-replicated-${row.item.id}-${item.id}`"
                      :title="
                        $t('evaluations.newEvaluations.replicatedEvaluations', {
                          entity: $getVisibleNames(
                            'evaluations2.test',
                            true,
                            'Instrumentos'
                          ),
                        })
                      "
                      hide-footer
                      size="lg"
                    >
                      <b-form-group
                        :label="
                          $t(
                            'evaluations.newEvaluations.instrumentsReplicatedInEvaluations',
                            {
                              entity: $getVisibleNames(
                                'evaluations2.test',
                                true,
                                'Instrumentos'
                              ),
                            }
                          )
                        "
                        label-for="selected_evaluations_ids"
                        label-cols="0"
                        label-cols-sm="auto"
                        label-cols-md="auto"
                        class="m-0 p-0 mb-2 d-flex align-items-center"
                      >
                      </b-form-group>
                      <template
                        v-for="evaluation_selected in selectedEvaluationsWithDetails"
                      >
                        <div :key="evaluation_selected.id">
                          <span
                            v-b-tooltip.v-secondary.noninteractive.hover.right="{
                              title: $t(
                                'evaluations.newEvaluations.goToEntity',
                                {
                                  entity: $getVisibleNames(
                                    'evaluations2.evaluation',
                                    false,
                                    'Evaluación'
                                  ),
                                }
                              ),
                              boundary: 'viewport',
                            }"
                            class="div-href"
                            @click="
                              redirectToEvaluationReplicatedFromInstrument(
                                evaluation_selected.id
                              )
                            "
                          >
                            -{{ evaluation_selected.full_name }}
                          </span>
                        </div>
                      </template>
                      <div class="d-flex">
                        <b-button
                          class="ml-auto mr-0"
                          size="sm"
                          @click="
                            $bvModal.hide(
                              `modal-redirect-to-evaluation-replicated-${row.item.id}-${item.id}`
                            )
                          "
                        >
                          {{ $t("reusable.common.close") }}
                        </b-button>
                      </div>
                    </b-modal>
                    <b-modal
                      :id="`modal-edit-instrument-${item.id}`"
                      :title="
                        $t('reusable.common.editTooltip', {
                          entity: $getVisibleNames(
                            'evaluations2.test',
                            false,
                            'Instrumento'
                          ),
                        })
                      "
                      size="xl"
                      hide-footer
                    >
                      <NewInstrumentForm
                        :evaluation_id="row.item.id"
                        :Instrument="item"
                        :show_step="
                          row.item.matter_evaluation != null ||
                          row.item.egress_profile_matter_evaluation != null
                        "
                        :locked_instrument="item.is_locked"
                        :ClosedEvaluatee="existEvaluateeTest(item.id)"
                        :show_delete_button="true"
                        @closeModal="
                          $bvModal.hide(`modal-edit-instrument-${item.id}`)
                        "
                      ></NewInstrumentForm>
                    </b-modal>
                  </b-td>
                </b-tr>
              </template>
              <template v-else>
                <b-tr>
                  <b-td :colspan="6">
                    {{
                      $t("evaluations.newEvaluations.noEntityForEntity", {
                        entity1: $getVisibleNames(
                          "evaluations2.test",
                          true,
                          "Instrumentos"
                        ),
                        entity2: $getVisibleNames(
                          "evaluations2.evaluation",
                          false,
                          "Evaluación"
                        ),
                      })
                    }}.</b-td
                  >
                </b-tr>
              </template>
            </b-tbody>
          </b-table-simple>
        </div>
      </template>
      <template #cell(actions)="row">
        <div class="container-edit">
          <button-edit
            :title="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'teaching.evaluation',
                  false,
                  'Evaluación'
                ),
              })
            "
            size="sm"
            class="evaluation-edit mb-2"
            v-can="'teaching.change_evaluation'"
            v-if="allows_crud && !row.item.is_locked"
            v-b-tooltip.v-secondary.topright.noninteractive="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'teaching.evaluation',
                  false,
                  'Evaluación'
                ),
              })
            "
            @click="$bvModal.show(`modal-edit-evaluation-${row.item.id}`)"
          ></button-edit>
          <button-delete
            v-if="
              allows_crud &&
              !existEvaluateeEvaluation(row.item.id) &&
              !row.item.is_locked
            "
            size="sm"
            class="evaluation-delete mb-2"
            v-can="'evaluations2.delete_evaluation'"
            v-b-tooltip.v-secondary.topright.noninteractive="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames(
                  'teaching.evaluation',
                  false,
                  'Evaluación'
                ),
              })
            "
            @click="askForDeleteEvaluation(row.item.id)"
          ></button-delete>
          <b-modal
            :id="`modal-edit-evaluation-${row.item.id}`"
            :title="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'teaching.evaluation',
                  false,
                  'Evaluación'
                ),
              })
            "
            hide-footer
            size="xl"
          >
            <NewEvaluationForm
              :Evaluation="row.item"
              :evaluation_scoped_id="evaluation_scoped"
              :evaluation_scoped_object_id="evaluation_scoped_object_id"
              :Sections="Sections"
              :Matters="Matters"
              :show_step="
                row.item.matter_evaluation != null ||
                row.item.egress_profile_matter_evaluation != null ||
                row.item.scope == 1
              "
              :ClosedEvaluatee="existEvaluateeEvaluation(row.item.id)"
              :EgressProfileMatters="EgressProfileMatters"
              @closeModal="closeModal()"
            ></NewEvaluationForm>
          </b-modal>
        </div>
      </template>
    </NewGenericBTable>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";
import vSelect from "vue-select";
export default {
  name: "ManageEvaluationTable",
  components: {
    vSelect,
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    NewGenericBTable: () => import("@/components/reusable/NewGenericBTable"),
    NewEvaluationForm: () =>
      import(
        "@/components/new-evaluations/ManageEvaluations/NewEvaluationForm"
      ),
    NewInstrumentForm: () =>
      import("@/components/new-evaluations/Evaluation/NewInstrumentForm"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
  },
  props: {
    evaluation_scoped: {
      type: Number,
      required: true,
    },
    evaluation_scoped_object_id: {
      type: Number,
    },
    pre_filter: {
      type: String,
      required: true,
    },
    allows_crud: {
      required: true,
      type: Boolean,
    },
    Sections: {
      type: Array,
    },
    Matters: {
      type: Array,
    },
    EgressProfileMatters: {
      type: Array,
    },
    redirect_to_evaluatee_view: {
      default: false,
      required: false,
    },
    reorderable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      generic_table_key: 0,
      prevent_close_modal: false,
      change_evaluation_form: false,
      available_sections_to_replicate_section_evaluation: [],
      available_sections_to_replicate_section_evaluation_all: [],
      selected_section_evaluation_ids: [],
      selected_evaluations_ids: [],
      current_test_id: null,
      current_evaluation_id: null,
      selected_sections_details: [],
      disable_replicate_buttons: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      evaluations: names.NEW_EVALUATIONS,
      evaluation_types: names.NEW_EVALUATION_TYPES,
      evaluation_categories: names.NEW_EVALUATION_CATEGORIES,
      sections: names.SECTIONS,
      new_tests: names.NEW_TESTS,
      egress_profiles: names.EGRESS_PROFILES,
      careers: names.CAREERS,
      faculties: names.FACULTIES,
      campuses: names.CAMPUSES,
      typesDefault: names.NEW_TEST_TYPES,
      evaluatee_evaluations: names.EVALUATEE_EVALUATIONS,
      evaluatee_tests: names.EVALUATEE_TESTS,
    }),
    fields() {
      return [
        {
          key: "title",
          label: this.$getVisibleNames(
            "evaluations2.evaluation",
            false,
            "Evaluación"
          ),
          sortable: true,
          display_column: true,
        },
        {
          key: "description",
          label: this.$t("evaluations.newEvaluations.description"),
          sortable: false,
          display_column: false,
        },
        {
          key: "scope",
          label: this.dinamicHeader(),
          sortable: false,
          display_column: !this.redirect_to_evaluatee_view,
        },
        {
          key: "type",
          label: this.$t("evaluations.newEvaluations.type"),
          sortable: false,
          display_column: true,
          formatter: (value) => {
            return (
              (this.evaluation_types.find((x) => x.id == value) || {}).value ||
              "N/A"
            );
          },
        },
        {
          key: "weighing",
          label: this.$t("evaluations.newEvaluations.weighting"),
          sortable: false,
          display_column: true,
          formatter: (value) => {
            return value == null || value == 0 ? "N/A" : value + "%";
          },
        },
        // {
        //   key: "category",
        //   label: "Categoría",
        //   sortable: false,
        //   display_column: false,
        //   formatter: (value) => {
        //     return (
        //       (this.evaluation_categories.find((x) => x.id == value) || {})
        //         .value || "N/A"
        //     );
        //   },
        // },
        {
          key: "instrument",
          label: this.$getVisibleNames(
            "evaluations2.test",
            true,
            "Instrumentos"
          ),
          display_column: true,
          tdClass: "text-center",
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thStyle: "width: 1%;",
          thClass: "noprint",
          tdClass: "text-center noprint",
        },
      ];
    },
    sectionsProfessor() {
      if (this.user)
        return this.sections.filter((x) => x.professors.includes(this.user.id));
      else return [];
    },
    replicateEvaluationsList() {
      // Obtener la evaluación actual basada en current_evaluation_id
      const currentEvaluation = this.evaluations.find(
        (x) => x.id == this.current_evaluation_id
      );

      if (!currentEvaluation) return [];

      if (currentEvaluation.scope == 1) {
        const sections_professor = this.sectionsProfessor.map((x) => x.id);
        return this.evaluations
          .filter(
            (x) =>
              x.scope == 1 &&
              sections_professor.includes(x.scope_id) &&
              x.parent_evaluation == currentEvaluation.parent_evaluation
          )
          .map((x) => {
            const section_name = this.sectionsProfessor.find(
              (a) => a.id == x.scope_id && x.scope === 1
            );
            return {
              ...x,
              full_name: section_name
                ? section_name.name + " - " + x.title
                : x.title,
              is_active: section_name ? section_name.is_active : true,
            };
          })
          .sort((a, b) =>
            a.full_name.toLowerCase().localeCompare(b.full_name.toLowerCase())
          );
      } else if ([2, 3].includes(currentEvaluation.scope)) {
        return this.evaluations
          .filter(
            (x) =>
              x.scope == currentEvaluation.scope &&
              x.scope_id == currentEvaluation.scope_id
          )
          .map((x) => ({ ...x, full_name: x.title }))
          .sort((a, b) =>
            a.full_name.toLowerCase().localeCompare(b.full_name.toLowerCase())
          );
      } else {
        return [];
      }
    },
    selectedEvaluationsWithDetails() {
      return this.replicateEvaluationsList.filter((evaluation) =>
        this.selected_evaluations_ids.includes(evaluation.id)
      );
    },
    tablePreFilter() {
      // last-wins: si el usuario ordena manualmente por "título" en la tabla,
      // NewGenericBTable agrega su propio &ordering= al final y ese gana.
      return this.reorderable
        ? `${this.pre_filter}&ordering=order`
        : this.pre_filter;
    },
  },
  methods: {
    section(section_id) {
      const section = this.sections.find((x) => x.id == section_id);
      return section && section.professors.includes(this.user.id);
    },
    handleRowReorder(reordered_items) {
      let order = 1;
      reordered_items.forEach((evaluation) => {
        if (evaluation.order != order) {
          evaluation.order = order;
          this.patchEvaluationOrder(evaluation);
        }
        order += 1;
      });
    },
    patchEvaluationOrder(evaluation) {
      this.$store.dispatch(names.PATCH_NEW_EVALUATION, {
        new_evaluation_id: evaluation.id,
        item: { order: evaluation.order },
      });
    },
    openReplicateTest(evaluation, test) {
      this.current_test_id = test.id;
      this.current_evaluation_id = evaluation.id;

      if (this.sectionsProfessor.length > 0 && evaluation.scope == 1) {
        this.$store.dispatch(names.FETCH_NEW_EVALUATIONS, {
          scoped_id: 1,
          scoped_object_ids: this.sectionsProfessor.map((x) => x.id),
          parent_evaluation_id: evaluation.parent_evaluation,
        });
      } else if ([2, 3].includes(evaluation.scope)) {
        this.$store.dispatch(names.FETCH_NEW_EVALUATIONS, {
          scoped_id: evaluation.scope,
          scoped_object_id: evaluation.scope_id,
        });
      }
      this.$bvModal.show(`modal-copy-instrument-${evaluation.id}-${test.id}`);
    },
    openReplicateEvaluationInSectionEvaluation(evaluation) {
      this.fetchAvailableSectionEvaluationToReplicateEvaluation(evaluation);
      this.$bvModal.show(
        `modal-copy-evaluation-in-section-evaluation-${evaluation.id}`
      );
    },
    dropdownShouldOpen3(VueSelect) {
      if (this.available_sections_to_replicate_section_evaluation.length > 0) {
        return VueSelect.open;
      }
      return VueSelect.search.length !== 0 && VueSelect.open;
    },
    replicateEvaluationInSectionEvaluation(evaluation) {
      this.disable_replicate_buttons = true;
      this.$restful
        .Post(`/evaluations2/replicate_section_evaluation_to_other_sections/`, {
          evaluation_id: evaluation.id,
          section_ids: this.selected_section_evaluation_ids,
        })
        .then((response) => {
          // Mantener solo la evaluación actual y limpiar las demás del store
          this.$store.commit(names.MUTATE_NEW_EVALUATIONS, [evaluation]);
          this.fetchAvailableSectionEvaluationToReplicateEvaluation(evaluation);
          this.selected_sections_details = response;
          this.$bvModal.show(`modal-redirect-to-evaluation-${evaluation.id}`);
          // this.$bvModal.hide(
          //   `modal-copy-evaluation-in-section-evaluation-${this.evaluation.id}`
          // );
          // this.generic_table_key++;
          this.disable_replicate_buttons = false;
        });
    },
    fetchAvailableSectionEvaluationToReplicateEvaluation(evaluation) {
      if (evaluation && evaluation.scope == 1) {
        this.available_sections_to_replicate_section_evaluation =
          this.available_sections_to_replicate_section_evaluation_all.filter(
            (x) => x.compare_evaluation == evaluation.id
          );
        this.available_sections_to_replicate_section_evaluation.unshift({
          id: "all",
          name: this.$t("evaluations.newEvaluations.all"),
        });
        // this.$restful
        //   .Get(
        //     `/evaluations2/available_sections_to_replicate_section_evaluation/?evaluation_id=${evaluation.id}`
        //   )
        //   .then((response) => {
        //     this.available_sections_to_replicate_section_evaluation = [
        //       { id: "all", name: "-- TODOS --" },
        //       ...response,
        //     ];
        //   });
      }
    },
    fetchAvailableSectionEvaluationsToReplicateEvaluation(evaluation) {
      if (evaluation && evaluation.scope == 1) {
        // TODO: pasar a in el evaluation para multiples.
        this.$restful
          .Get(
            `/evaluations2/available_sections_to_replicate_section_evaluation/?evaluation_id=${evaluation.id}`
          )
          .then((response) => {
            this.available_sections_to_replicate_section_evaluation_all =
              this.available_sections_to_replicate_section_evaluation_all.concat(
                response.map((x) => {
                  return { ...x, compare_evaluation: evaluation.id };
                })
              );
          });
      }
    },
    confirmClose(bvModalEvt) {
      if (
        bvModalEvt.trigger === "headerclose" ||
        bvModalEvt.trigger === "event"
      ) {
        this.change_evaluation_form = false;
        return;
      }
      if (!this.prevent_close_modal && this.change_evaluation_form) {
        bvModalEvt.preventDefault();
        this.$bvModal
          .msgBoxConfirm(
            this.$t("evaluations.newEvaluations.sureCloseUnsavedData"),
            {
              title: this.$t("evaluations.newEvaluations.confirmationRequired"),
              size: "md",
              buttonSize: "md",
              okVariant: "warning",
              okTitle: this.$t("evaluations.newEvaluations.yesClose"),
              cancelTitle: this.$t("reusable.common.cancel"),
              footerClass: "p-2",
              hideHeaderClose: true,
              centered: true,
              headerClass: "text-black",
              header: {
                title: this.$t(
                  "evaluations.newEvaluations.confirmationRequired"
                ),
                class: "text-center",
              },
            }
          )
          .then((value) => {
            if (value) {
              this.prevent_close_modal = true;
              this.$bvModal.hide(bvModalEvt.componentId);
              this.$nextTick(() => {
                this.change_evaluation_form = false;
                this.prevent_close_modal = false;
              });
            }
          });
      }
    },
    filterTest(evaluation_id) {
      return this.new_tests.filter((x) => x.evaluation == evaluation_id);
    },
    isWeighingSumValid(evaluation_id) {
      const tests = this.filterTest(evaluation_id);
      const totalWeighing = tests.reduce(
        (sum, test) => sum + (test.weighing || 0),
        0
      );
      return totalWeighing === 100;
    },
    // instrumentWeighing(score, evaluation_id) {
    //   const maxScore = this.new_tests
    //     .filter((x) => x.evaluation == evaluation_id)
    //     .reduce((accumulator, x) => {
    //       return accumulator + x.max_score;
    //     }, 0);
    //   if (maxScore == 0) return 0;
    //   return (score / maxScore) * 100;
    // },
    existEvaluateeEvaluation(evaluation_id) {
      if (
        this.evaluatee_evaluations.filter((x) => x.evaluation == evaluation_id)
          .length > 0
      )
        return true;
      else return false;
    },
    existEvaluateeTest(test_id) {
      if (
        this.evaluatee_tests.filter(
          (x) =>
            x.test == test_id &&
            (x.start_time != null ||
              x.is_corrected ||
              x.finished_at ||
              x.is_published)
        ).length > 0
      )
        return true;
      else return false;
    },
    FetchInstrument(items) {
      items.forEach((evaluation) => {
        this.fetchAvailableSectionEvaluationsToReplicateEvaluation(evaluation);
      });
      const evaluations_ids = items.map((x) => x.id);
      this.$store
        .dispatch(names.FETCH_NEW_TESTS, {
          evaluations_ids: evaluations_ids,
        })
        .then((response) => {
          this.$store.dispatch(names.FETCH_EVALUATEE_TESTS, {
            tests_ids: response.map((x) => x.id),
          });
        });
      this.$store.dispatch(names.FETCH_EVALUATEE_EVALUATIONS, {
        evaluations_ids: evaluations_ids,
      });
    },
    redirectToEvaluationReplicated(evaluation_id, instrument_id = null) {
      // Cerrar ambos modales
      this.$bvModal.hide(`modal-redirect-to-evaluation-${evaluation_id}`);
      this.$bvModal.hide(
        `modal-copy-evaluation-in-section-evaluation-${evaluation_id}`
      );

      // Redirigir a la evaluación
      const url = this.$router.resolve({
        name: "NewEvaluationView",
        params: {
          evaluation_id: evaluation_id,
          instrument_id: instrument_id,
        },
      }).href;
      window.open(url, "_blank");
    },

    redirectToEvaluationReplicatedFromInstrument(evaluation_id, instrument_id) {
      // Cerrar ambos modales
      this.$bvModal.hide(
        `modal-redirect-to-evaluation-replicated-${evaluation_id}-${instrument_id}`
      );
      this.$bvModal.hide(
        `modal-copy-instrument-${evaluation_id}-${instrument_id}`
      );

      // Redirigir a la evaluación
      const url = this.$router.resolve({
        name: "NewEvaluationView",
        params: {
          evaluation_id: evaluation_id,
          instrument_id: instrument_id,
        },
      }).href;
      window.open(url, "_blank");
    },
    redirectToEvaluation(evaluation_id, instrument_id = null) {
      this.$router.push({
        name: "NewEvaluationView",
        params: {
          evaluation_id: evaluation_id,
          instrument_id: instrument_id,
        },
      });
    },
    redirectToEvaluateeEvaluation(evaluation_id, instrument_id = null) {
      this.$router.push({
        name: "EvaluateeView",
        params: {
          evaluation_id: evaluation_id,
          instrument_id: instrument_id,
        },
      });
    },
    closeModal(evaluation_id) {
      this.$bvModal.show(`modal-edit-evaluation-${evaluation_id}`);
      this.generic_table_key++;
    },
    askForDeleteEvaluation(evaluation_id) {
      this.$swal({
        title: `<p>${this.$t(
          "evaluations.newEvaluations.sureToDeleteEntityAndInstruments",
          {
            entity: this.$getVisibleNames(
              "evaluations2.evaluation",
              false,
              "Evaluación"
            ).toLowerCase(),
          }
        )}</p>`,
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_NEW_EVALUATION, evaluation_id)
            .then(() => {
              this.generic_table_key++;
              toast(
                this.$t("evaluations.newEvaluations.wasDeletedThe") +
                  " " +
                  this.$getVisibleNames(
                    "evaluations2.evaluation",
                    false,
                    "Evaluación"
                  )
              );
            });
        }
      });
    },
    changeStateTest(test) {
      const payload = {
        new_test_id: test.id,
        item: {
          is_locked: !test.is_locked,
        },
      };
      this.$store.dispatch(names.PATCH_NEW_TEST, payload);
    },
    askForDeleteInstrument(instrument_id) {
      this.$swal({
        title: `<p>${this.$t("reusable.common.deleteConfirmTitle2", {
          article: "el",
          entity: this.$getVisibleNames(
            "evaluations2.test",
            false,
            "Instrumento"
          ).toLowerCase(),
        })}</p>`,
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(names.DELETE_NEW_TEST, instrument_id);
          toast(
            this.$t("evaluations.newEvaluations.wasDeletedTheMale") +
              " " +
              this.$getVisibleNames("evaluations2.test", false, "Instrumento")
          );
        }
      });
    },
    dinamicHeader() {
      if (this.evaluation_scoped == 1)
        return this.$getVisibleNames("teaching.section", true, "Sección");
      else if (this.evaluation_scoped == 2)
        return this.$getVisibleNames(
          "mesh.egressprofilematter",
          true,
          "Asignatura"
        );
      else if (this.evaluation_scoped == 3)
        return this.$getVisibleNames(
          "teaching.matter",
          true,
          "Asignatura Base"
        );
      else if (this.evaluation_scoped == 4)
        return this.$getVisibleNames(
          "mesh.egressprofile",
          true,
          "Perfil De Egreso"
        );
      else if (this.evaluation_scoped == 5)
        return this.$getVisibleNames("mesh.career", true, "Programa");
      else if (this.evaluation_scoped == 6)
        return this.$getVisibleNames("mesh.faculty", true, "Facultad");
      else if (this.evaluation_scoped == 7)
        return this.$getVisibleNames("mesh.campus", true, "Sede");
      else return "";
    },
    findScopedId(scoped_id) {
      if (this.evaluation_scoped == 1)
        return (this.Sections.find((x) => x.id == scoped_id) || {}).name || "";
      else if (this.evaluation_scoped == 2)
        return (
          (this.EgressProfileMatters.find((x) => x.id == scoped_id) || {})
            .matter_name || ""
        );
      else if (this.evaluation_scoped == 3)
        return (this.Matters.find((x) => x.id == scoped_id) || {}).name || "";
      else if (this.evaluation_scoped == 4)
        return (
          (this.egress_profiles.find((x) => x.id == scoped_id) || {}).name || ""
        );
      else if (this.evaluation_scoped == 5)
        return (this.careers.find((x) => x.id == scoped_id) || {}).name || "";
      else if (this.evaluation_scoped == 6)
        return (this.faculties.find((x) => x.id == scoped_id) || {}).name || "";
      else if (this.evaluation_scoped == 7)
        return (this.campuses.find((x) => x.id == scoped_id) || {}).name || "";
      else return "";
    },
    dropdownShouldOpen(VueSelect) {
      if (this.replicateEvaluationsList.length > 0) {
        return VueSelect.open;
      }
      return VueSelect.search.length !== 0 && VueSelect.open;
    },
    async replicateTests() {
      if (this.selected_evaluations_ids.length > 0) {
        this.disable_replicate_buttons = true;

        for await (let evaluation_id of this.selected_evaluations_ids) {
          await this.$restful
            .Get(
              `/evaluations2/copy_test_and_set_evaluation/?test=${this.current_test_id}&to_evaluation=${evaluation_id}`
            )
            .then((test_id) => {
              if (evaluation_id != this.current_evaluation_id) {
                this.$store.dispatch(names.FETCH_NEW_TEST, {
                  test_id: test_id,
                });
                this.$store.dispatch(names.FETCH_NEW_RUBRIC_INSTRUMENTS, {
                  test_id: test_id,
                });
                this.$store.dispatch(
                  names.FETCH_NEW_TEST_EVALUATION_CRITERIA_MICROS,
                  {
                    test_id: test_id,
                  }
                );
              }
            });
        }
        this.$bvModal.show(
          `modal-redirect-to-evaluation-replicated-${this.current_evaluation_id}-${this.current_test_id}`
        );
        // this.$bvModal.hide(
        //   `modal-copy-instrument-${this.current_evaluation_id}-${this.current_test_id}`
        // );
        this.disable_replicate_buttons = false;
        // this.generic_table_key++;
      }
    },
  },
  created() {},
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.btn-details,
.btn-instrument {
  display: table;
  margin: 0 auto;
  min-width: 10.5em;
  background-color: var(--kl-primary-button-color) !important;
  color: #fff;
}
.btn-details:hover,
.btn-instrument:hover {
  background-color: var(--kl-primary-button-hover-color) !important;
}
.container-edit {
  display: flex;
  flex-direction: column;
  margin-right: 5px;
}
.evaluation-edit,
.evaluation-delete {
  background-color: var(--kl-primary-button-color);
  color: var(--secondary-font-color);
  width: 2em;
  margin-right: 0 !important;
  max-height: 30px;
}
.evaluation-edit:hover {
  background: var(--kl-primary-button-hover-color);
}
.evaluation-delete {
  background-color: #dc3545 !important;
}
.evaluation-delete:hover {
  background-color: #e45d6b !important;
}
.th-class {
  background: #e0f1ff !important;
  color: #006ec8 !important;
}
.div-href {
  color: #007bff;
}
.div-href:hover {
  color: #0057b1 !important;
  text-decoration: underline;
  cursor: pointer;
}
.weighing-error {
  color: #dc3545 !important;
  font-weight: bold;
}
</style>
